import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

//import update from "immutability-helper";
//import moment from 'moment';

//- Material UI / Style
import { withStyles } from '@material-ui/core/styles';
import { ResponsiveContainer, PieChart, Pie, Cell, Legend } from 'recharts';
import Paper from '@material-ui/core/Paper';
import { getGlobalClasses } from '../../themes';

//containers
import AuthUserContainer from '../../containers/AuthUser';
import TimeClockPermissionContainer from '../../containers/TimeClock/TimeClockPermission';
import LateAnalysisContainer from '../../containers/Reporting/LateAnalysis';

import InfoIcon from '@material-ui/icons/Info';
import CheckIcon from '@material-ui/icons/Check';

//- UI / Form
import FormComponent from '../../components/FormComponent';
import EnhancedTable from '../../components/table/EnhancedTable';
import { diffToColor } from './helper';
import { Tooltip } from '@material-ui/core';

const styles = (theme) => {
	return {
		...getGlobalClasses(theme),
		submitButton: {
			marginTop: 20,
			fontSize: 16,
			borderRadius: '100px',
			padding: '13px 45px',
			textTransform: 'uppercase',
			marginRight: 10,
		},
		label: {
			padding: 5,
			paddingRight: 2,
			fontWeight: 500,
			textAlign: 'right',
			fontSize: 16,
			textTransform: 'uppercase',
		},
		value: {
			padding: 5,
			paddingLeft: 10,
			paddingRight: 10,
			fontSize: 18,
		},
		stat: {
			display: 'flex',
			flexDirection: 'row',
			alignItems: 'center',
		},
		dateNote: {
			color: '#666',
			fontSize: 13,
		},
		noteContainer: {
			borderBottom: '1px solid #f5f5f5',
		},

		upIcon: {
			marginTop: -15,
			bottom: -6,
			width: 28,
			height: 22,
			position: 'relative',
			fontWeight: 900,
			color: '#4CAF50',
		},
		downIcon: {
			marginTop: -15,
			bottom: -6,
			width: 28,
			height: 22,
			position: 'relative',
			fontWeight: 900,
			color: '#FF500F',
		},
	};
};

const RADIAN = Math.PI / 180;
const renderCustomizedLabel = (p) => {
	const { cx, cy, midAngle, innerRadius, outerRadius, percent } = p;
	const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
	const x = cx + radius * Math.cos(-midAngle * RADIAN);
	const y = cy + radius * Math.sin(-midAngle * RADIAN);

	return (
		<text x={x} y={y} fill="white" textAnchor={x > cx ? 'start' : 'end'} dominantBaseline="central">
			{`${(percent * 100).toFixed(0)}%`}
		</text>
	);
};

/*
const RADIAN = Math.PI / 180;
const renderCustomizedLabel = (p) => {
	const { cx, cy, midAngle, innerRadius, outerRadius, percent } = p;
	const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
	const x = cx + radius * Math.cos(-midAngle * RADIAN);
	const y = cy + radius * Math.sin(-midAngle * RADIAN);

	return `${(percent * 100).toFixed(0)}%`;
};
*/

function formatDiff(diff) {
	if (!_.isNumber(diff)) {
		return '-';
	}
	if (diff === 0) {
		return 'on time';
	} else if (diff <= 0) {
		return `${Math.abs(_.round(diff))} minutes early`;
	} else {
		return `${Math.abs(_.round(diff))} minutes late`;
	}
}

class LateAnalysisDetails extends FormComponent {
	constructor(props) {
		super(props);

		const afterDate = _.get(this.props, 'match.params.afterDate');
		const beforeDate = _.get(this.props, 'match.params.beforeDate');
		const userId = parseInt(_.get(this.props, 'match.params.userId'));

		this.state = {
			afterDate,
			beforeDate,
			userId,
		};
	}

	componentDidMount() {
		this.handleSearch();
	}

	getApiParams = () => {
		const { accessToken } = this.props;
		const { afterDate, beforeDate, userId } = this.state;

		const params = {
			accessToken,
			shiftForUserIds: [userId],
			afterDate: moment(afterDate).format('YYYY-MM-DD'),
			beforeDate: moment(beforeDate).format('YYYY-MM-DD'),
		};
		return params;
	};

	handleSearch = () => {
		const { showErrors, runLateAnalysisReport } = this.props;

		this.setState({
			isSearching: true,
			refreshId: this.state.refreshId + 1,
			hasResults: true,
		});

		runLateAnalysisReport({
			params: this.getApiParams(),
			callback: (err, r) => {
				this.setState({ isExporting: false });
				if (err) {
					return showErrors(_.isArray(err) ? err : [err]);
				}

				this.setState({ isSearching: false });
				this.formatResults({ apiResults: r });
			},
		});
	};

	formatResults = ({ apiResults }) => {
		const { userMap, showErrors } = this.props;

		const { lateAnalysisRows } = apiResults;
		// const { workDayCollection, shiftCollection, equipmentCollection } = collections;
		// const workDayLookup = _.keyBy(workDayCollection, 'workDayId');
		// const shiftMap = _.keyBy(shiftCollection, 'shiftId');
		// const equipmentMap = _.keyBy(equipmentCollection, 'equipmentId');

		const { userId } = this.state;
		const lateAnalysisRow = _.find(lateAnalysisRows, { userId });

		if (!lateAnalysisRow) {
			showErrors(`Could not find late analysis for user: ${userId}`);
			return;
		}

		const dateRows = lateAnalysisRow.dateRows;
		const formattedRows = [];
		dateRows.forEach((dateRow) => {
			const {
				date,
				calledInLate,
				diff,
				sphereClosestClockInDateTime,
				tmwShiftStartDateTime,
				daysOnTmwScheduleButMissingSphereClockIn,
			} = dateRow;

			const row = {
				key: date,
				date,
				dateDisplay: moment(date).format('M/D/YY'),
				calledInLate,
				calledInLateDisplay: calledInLate ? <CheckIcon style={{ color: 'red' }} /> : '-',
				diff,
				diffDisplay: formatDiff(diff),
				diffStyle: {
					backgroundColor: diffToColor(diff),
				},
				tmwShiftStartDateTime,
				tmwShiftStartDateTimeDisplay: !tmwShiftStartDateTime
					? 'not on schedule'
					: moment(tmwShiftStartDateTime).format('M/D h:mm a'),
				sphereClosestClockInDateTime,
				sphereClosestClockInDateTimeDisplay: daysOnTmwScheduleButMissingSphereClockIn ? (
					<span style={{ fontWeight: 'bold', color: 'red' }}>missing</span>
				) : sphereClosestClockInDateTime ? (
					moment(sphereClosestClockInDateTime).format('M/D h:mm a')
				) : (
					'-'
				),
			};
			formattedRows.push(row);
		});

		const {
			daysOnSchedule,
			daysNotOnSchedule,

			daysOver30Early,
			daysBetween10and30Early,
			daysBetween10and10,
			daysBetween10and30Late,
			daysOver30Late,

			daysOnTmwScheduleButMissingSphereClockIn,
			averageClockInDifference,
		} = lateAnalysisRow;

		const user = userMap[userId] || {
			firstName: 'Missing',
			lastName: userId,
		};
		const driverDisplay = `${user.firstName} ${user.lastName}`;
		const row = {
			driverDisplay,
			daysOnSchedule,
			daysNotOnSchedule,

			daysOver30Early,
			daysBetween10and30Early,
			daysBetween10and10,
			daysBetween10and30Late,
			daysOver30Late,

			daysOnTmwScheduleButMissingSphereClockIn,
			averageClockInDifference,
			averageClockInDifferenceDisplay: formatDiff(averageClockInDifference),
		};
		this.setState({ formattedRows, driverStats: row });
	};

	render() {
		const { permissions, classes } = this.props;
		const { afterDate, beforeDate, userId } = this.state;

		if (!permissions || !_.includes(permissions, 'canRunAttendanceReports')) {
			return <div>You do not have valid permissions to view this page.</div>;
		}

		if (!afterDate || !beforeDate || !userId) {
			return <div>Invalid URL</div>;
		}
		return (
			<>
				<div className={classes.globalMainHeadline}>Driver Detail Report</div>
				<Paper className={classes.globalMainPaper}>{this.renderStats()}</Paper>
				<div className={classes.globalMainHeadline}>Day by Day Breakdown</div>
				<Paper className={classes.globalMainPaper}>{this.renderResults()}</Paper>
			</>
		);
	}

	renderStat = ({ stat }) => {
		const { classes } = this.props;
		const { key, includeScheduleHelp, display } = stat;
		const { driverStats } = this.state;

		return (
			<div className={classes.stat} key={key}>
				<div className={classes.label}>{display || _.startCase(key)}</div>
				<div className={classes.value}>{driverStats[key]}</div>

				{includeScheduleHelp && (
					<div>
						<Tooltip
							title={
								<div
									style={{
										fontSize: 16,
										lineHeight: 1.2,
										padding: 10,
									}}
								>
									Days on schedule means that a shift was found on the TMW dispatch schedule.
								</div>
							}
						>
							<InfoIcon
								style={{
									cursor: 'pointer',
									fontSize: 18,
									color: '#1289d4',
								}}
							/>
						</Tooltip>
					</div>
				)}
			</div>
		);
	};
	renderChart = () => {
		const { driverStats } = this.state;

		const {
			daysBetween10and10,
			daysBetween10and30Early,
			daysBetween10and30Late,
			daysOver30Early,
			daysOver30Late,
		} = driverStats;

		const data = [
			{ name: 'On Time (Between 10 and 10)', value: daysBetween10and10, color: '#4CAF50' },
			{ name: 'Early (10 - 30m)', value: daysBetween10and30Early, color: '#CDDC39' },
			{ name: 'Late (10 - 30m)', value: daysBetween10and30Late, color: '#FFCA28' },
			{ name: 'Very Early (30m+)', value: daysOver30Early, color: '#FF5722' },
			{ name: 'Very Late (30m+)', value: daysOver30Late, color: '#F44336' },
		];

		return (
			<div style={{ width: '100%', height: '320px' }}>
				<ResponsiveContainer>
					<PieChart>
						<Pie
							data={data}
							cx="50%"
							cy="50%"
							labelLine={false}
							label={renderCustomizedLabel}
							outerRadius={140}
							fill="#8884d8"
							dataKey="value"
						>
							{data.map((entry, index) => (
								<Cell key={`cell-${index}`} fill={entry.color} />
							))}
						</Pie>
						<Legend layout="vertical" verticalAlign="middle" align="left" height={36} />
					</PieChart>
				</ResponsiveContainer>
			</div>
		);
	};

	renderStats = () => {
		// const { classes } = this.props;
		const { driverStats } = this.state;
		if (!driverStats) {
			return null;
		}

		const { driverDisplay } = driverStats;
		return (
			<div>
				<div style={{ fontSize: 28, marginBottom: 10 }}>Driver: {driverDisplay}</div>

				<div>
					<div>
						{[
							{ key: 'daysOnSchedule', includeScheduleHelp: true, display: 'Days on TMW Schedule' },
							{
								key: 'daysNotOnSchedule',
								includeScheduleHelp: true,
								display: 'Days not on TMW Schedule',
							},
						].map((stat) => {
							return this.renderStat({ stat });
						})}
					</div>
					<div
						style={{
							marginTop: 10,
							borderTop: '1px solid #eee',
							paddingTop: 10,
							display: 'flex',
							flexDirection: 'row',
						}}
					>
						<div style={{ width: '30%' }}>
							{[
								{ key: 'daysOnTimeOrEarly' },
								{ key: 'dayLessThan15MinutesLate', display: 'Days Late (less than 15 minutes)' },
								{
									key: 'dayMoreThan15AndLessThan30MinutesLate',
									display: 'Days late (15 to 30 minutes)',
								},
								{ key: 'daysOver30MinutesLate', display: 'Days late (over 30 minutes)' },
							].map((stat) => {
								return this.renderStat({ stat });
							})}
						</div>
						<div style={{ width: '50%' }}>{this.renderChart()}</div>
					</div>

					<div style={{ marginTop: 10, borderTop: '1px solid #eee', paddingTop: 10 }}>
						{[
							{
								key: 'averageClockInDifferenceDisplay',
								display: 'Average Difference (between shift start time / clock in time)',
							},
							{
								key: 'daysOnTmwScheduleButMissingSphereClockIn',
								display: 'Days on TMW Schedule but missing Sphere Clock In',
							},
						].map((stat) => {
							return this.renderStat({ stat });
						})}
					</div>
				</div>
			</div>
		);
	};

	renderResults = () => {
		const { formattedRows } = this.state;
		if (!formattedRows) {
			return null;
		}

		/* 
    TODO 
      At the top I want to make the OTHER API call to show the stats breakdown on this page
      
      -I want to show the time of the shift and the type (night vs day)
      -I also want to show the truck they are
      -Need to show if they are LATE or not in its own column
      -Need a final column for notes
    */

		const columns = [
			{
				label: 'Date',
				sortId: 'date',
				displayId: 'dateDisplay',
			},
			{
				label: 'TMW Scheduled Shift',
				sortId: 'tmwShiftStartDateTime',
				displayId: 'tmwShiftStartDateTimeDisplay',
			},
			{
				label: 'Sphere Clock In',
				sortId: 'sphereClosestClockInDateTime',
				displayId: 'sphereClosestClockInDateTimeDisplay',
			},
			{
				label: 'Difference',
				sortId: 'diff',
				displayId: 'diffDisplay',
				useStyle: 'diffStyle',
			},
			{
				label: 'Called in Late',
				sortId: 'calledInLate',
				displayId: 'calledInLateDisplay',
			},
		];

		return (
			<EnhancedTable
				rows={formattedRows}
				columns={columns}
				isDense={true}
				defaultOrderBy={'userId'}
				defaultOrder={'desc'}
			/>
		);
	};
}

LateAnalysisDetails.propTypes = {
	runDriverDetailReport: PropTypes.func.isRequired,
	userMap: PropTypes.object,

	showErrors: PropTypes.func.isRequired,
	authUser: PropTypes.object,
	classes: PropTypes.object.isRequired,
};

export default _.flow([
	withStyles(styles),
	AuthUserContainer,
	LateAnalysisContainer,
	TimeClockPermissionContainer,
])(LateAnalysisDetails);
